import { render, staticRenderFns } from "./TaskAdminLiuLanList.vue?vue&type=template&id=453c1d14&"
import script from "./TaskAdminLiuLanList.vue?vue&type=script&lang=js&"
export * from "./TaskAdminLiuLanList.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdminLiuLanList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports